import React, { FunctionComponent, useEffect, useState } from "react";
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import { url } from "../../Values/constants";
import axios from "axios";
import { DialogTitle } from "@mui/material";
import { connect, useDispatch } from "react-redux";
import { showSnackbarAction } from "../../Redux/actions";
import axiosHandler from "../../Services/axiosHandler";

type props = {
    history: any;
    openDialog: any;
    setOpenDialog: any;
    userDetails: any;
    bookingType?: any;
    setReason?: any;
    authToken: any;
};
const FormDialog: FunctionComponent<props> = ({
    history,
    openDialog,
    setOpenDialog,
    userDetails,
    bookingType,
    setReason,
    authToken
}) => {
    const dispatcher = useDispatch();
    const [contactNumber, setContactNumber] = useState<any>();
    const [textReason, setTextReason] = useState<any>();
    const [isError, setIsError] = useState<boolean>(false);
    const [isErrorMessage, setIsErrorMessage] = useState<any>(false);

    const handleChange = (e: any) => {
        setContactNumber(e.target.value);
    }
    const handleChangeRason = (e: any) => {
        setTextReason(e.target.value);
    }
    const handleClose = () => {
        setOpenDialog(false);
    };

    const handleSubmit = async () => {
        if (bookingType === "EDIT") {
            setReason(textReason);
            textReason && setOpenDialog(false);
        }
        else {
            const bodyData = {
                organization_id: userDetails.organization_id,
                uid: userDetails.uid,
                contact_no: contactNumber,
            }
            // axios.defaults.headers.common['x-access-token'] = authToken

            const getBookingContactNORes = await axiosHandler.post(
                url + '/bookings/details',
                bodyData
            );
            if (getBookingContactNORes.data) {
                history.push({
                    pathname: '/addBooking',
                    state: { "booking_type": "REBOOKING", "reBookingData": bodyData }
                })
            }
            else {
                dispatcher(
                    showSnackbarAction(
                        "No matching record(s) found for Bookings, you have searched for !!!",
                        "error"
                    )
                );
            }
        }
    }
    return (
        <div>
            <Dialog open={openDialog} onClose={handleClose}>
                {bookingType === "EDIT" ? <>
                    <DialogTitle>Reason</DialogTitle>
                    <DialogContent style={{ width: "100%" }}>
                        <TextField
                            autoFocus
                            margin="dense"
                            id="name"
                            required
                            label="Reason"
                            type="text"
                            multiline
                            rows={2}
                            maxRows={4}
                            fullWidth
                            variant="standard"
                            onChange={handleChangeRason}
                        />
                    </DialogContent>
                </> : <>
                    <DialogContent>
                        <TextField
                            autoFocus
                            margin="dense"
                            id="Contact_no"
                            label="Contact Number"
                            type="text"
                            fullWidth
                            variant="standard"
                            name="contactNumber"
                            onChange={handleChange}
                        // error={isError}
                        // helperText={isErrorMessage}
                        />
                    </DialogContent>
                </>}
                <DialogActions>
                    <Button onClick={handleClose}>Cancel</Button>
                    <Button onClick={handleSubmit}>Submit</Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}

const mapStateToProps = (state: any) => {
    return {
      user: state.user.data,
      theme: state.theme.isLightMode,
      authToken: state.user.authToken,
    };
  };
  export default connect(mapStateToProps)(FormDialog);